import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import secureLocalStorage from 'react-secure-storage';
import { getStoredData, getBooleanValue } from '@/utils/store';
import { CityData, OfficeData } from '@/types';

interface EntityState {
  userCity: CityData | null
  userAo: OfficeData | null
  cities: CityData[] // for super admin
  offices: OfficeData[] // for super admin
  citiesFetched: boolean
  officesFetched: boolean
  entityType: string
}

  const initialState: EntityState = {
    userCity: getStoredData<CityData | null>('userCity', null),
    userAo: getStoredData<OfficeData | null>('userAo', null),
    cities: getStoredData<CityData[]>('cities', []),
    offices: getStoredData<CityData[]>('offices', []),
    citiesFetched: getBooleanValue('citiesFetched'),
    officesFetched: getBooleanValue('officesFetched'),
    entityType: getStoredData<string>('entityType', '')
  };

const entitySlice = createSlice({
  name: 'entity',
  initialState,
  reducers: {
    setUserEntity: (state, action) => {
      state.entityType = action.payload.entityType;
      if (action.payload.entityType === 'city') {
        state.userCity = action.payload.userCity;
        secureLocalStorage.setItem('userCity', JSON.stringify(action.payload.userCity) || '');
      } else if (action.payload.entityType === 'ao') {
        state.userAo = action.payload.userAo;
        secureLocalStorage.setItem('userAo', JSON.stringify(action.payload.userAo) || '');
      }
      secureLocalStorage.setItem('entityType', JSON.stringify(action.payload.entityType) || '');
    },
    setCities: (state, action) => {
      state.cities = action.payload;
      state.citiesFetched = true;
      secureLocalStorage.setItem('cities', JSON.stringify(action.payload) || '');
      secureLocalStorage.setItem('citiesFetched', JSON.stringify(true) || '');
    },
    setOffices: (state, action) => {
      state.offices = action.payload;
      state.officesFetched = true;
      secureLocalStorage.setItem('offices', JSON.stringify(action.payload) || '');
      secureLocalStorage.setItem('officessFetched', JSON.stringify(true) || '');
    },
    clearEntity: (state) => {
      state.entityType = '';
      state.userCity = null;
      state.userAo = null;
      state.cities = [];
      state.offices = [];
      state.citiesFetched = false;
      state.officesFetched = false;
      secureLocalStorage.removeItem('entityType');
      secureLocalStorage.removeItem('userCity');
      secureLocalStorage.removeItem('userAo');
      secureLocalStorage.removeItem('cities');
      secureLocalStorage.removeItem('offices');
      secureLocalStorage.removeItem('citiesFetched');
      secureLocalStorage.removeItem('officessFetched');
    },
  },
});

export const { setCities, setOffices, setUserEntity, clearEntity } = entitySlice.actions;
export default entitySlice.reducer;
